import { CSSProperties, SVGProps } from 'react';

interface TidalPlatformIconProps extends SVGProps<SVGSVGElement> {
    className?: string;
    style?: CSSProperties;
    color?: string;
    size?: number;
    onClick?: () => void;
}

const TidalPlatformIcon = ({
    className,
    style,
    color,
    size = 52,
    onClick,
}: TidalPlatformIconProps) => (
    <svg
        className={className}
        style={style}
        width={size}
        height={size * (40 / 92)}
        onClick={onClick}
        viewBox="0 0 92 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_192_5090)">
            <path
                d="M34.1442 25.9162H31.9087V17.9875H29.0176V16.0713H37.0353V17.9875H34.1442V25.9162Z"
                fill={color}
            />
            <path
                d="M45.9729 25.9161H43.724V16.0713H45.9729V25.9161Z"
                fill={color}
            />
            <path
                d="M85.654 23.9734H89.5431V25.9165H83.4057V16.0716H85.654V23.9734Z"
                fill={color}
            />
            <path
                d="M53.4592 16.0695H57.1021C59.7897 16.0695 62.4639 17.4928 62.4639 20.9651C62.4639 24.2382 59.8427 25.9144 57.2349 25.9144H53.4592V16.0695ZM55.641 23.9847H57.0357C58.9117 23.9847 60.162 22.8143 60.162 20.9517C60.162 19.1823 58.8983 17.9857 57.0887 17.9857H55.641V23.9847Z"
                fill={color}
            />
            <path
                d="M74.9421 25.9162H77.414L73.358 16.0713H71.0366L66.9415 25.9162H69.3464L70.0721 23.9738H74.2232L74.9421 25.9162ZM70.6747 22.2245L72.1577 18.3744L73.6267 22.2245H70.6747Z"
                fill={color}
            />
            <path
                d="M13.9834 17.5058L11.102 20.3878L8.22009 17.5058L11.102 14.6251L13.9834 17.5058Z"
                fill={color}
            />
            <path
                d="M13.9834 23.2693L11.102 26.1512L8.22009 23.2693L11.102 20.3874L13.9834 23.2693Z"
                fill={color}
            />
            <path
                d="M8.22019 17.5061L5.33824 20.388L2.45691 17.5061L5.33824 14.6247L8.22019 17.5061Z"
                fill={color}
            />
            <path
                d="M19.7462 17.5061L16.8649 20.388L13.983 17.5061L16.8649 14.6247L19.7462 17.5061Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_192_5090">
                <rect
                    width="88" height="12.4404"
                    fill={color}
                    transform="translate(2 14.1678)"
                />
            </clipPath>
        </defs>
    </svg>
)

export default TidalPlatformIcon;
